import React, { useEffect } from 'react'
import { selectDescriptions } from '../../utils/utils'

export default function SeoText({ name, step, attributes }) {
  const {
    metaTitle = 'Custom Cushion Designer - Design your own Cushions',
    metaDescription = '',
    htmlTitle,
    htmlDescription,
  } = selectDescriptions(attributes, step)
  const hasSubtitle = htmlTitle?.length > 1
  const lastHtmlIndex = htmlDescription?.length - 1
  const leftHtmlDescription = htmlDescription?.slice(0, lastHtmlIndex / 2 + 1)
  const rightHtmlDescription = htmlDescription?.slice(lastHtmlIndex / 2 + 1)
  const lastHtmlDescription = htmlDescription?.[lastHtmlIndex]

  useEffect(() => {
    setMeta()
  }, [metaTitle, metaDescription, htmlTitle, htmlDescription])

  const setMeta = () => {
    document.title = metaTitle
    let metaDescriptionElement = document.querySelector('meta[name="description"]')

    if (!metaDescriptionElement) {
      metaDescriptionElement = document.createElement('meta')
      metaDescriptionElement.setAttribute('name', 'description')
      document.querySelector('head').appendChild(metaDescriptionElement)
    }

    metaDescriptionElement.setAttribute('content', metaDescription)
  }

  if (!htmlTitle && !htmlDescription) {
    return null
  }

  return (
    <div className="description">
      {!!htmlTitle && (
        <h1 className={hasSubtitle ? 'has-subtitle' : ''}> {htmlTitle?.[0] || name} </h1>
      )}
      {hasSubtitle ? <h2>{htmlTitle?.[1]}</h2> : null}
      {htmlDescription ? (
        <div className="description-paragraphs-external-wrapper">
          { leftHtmlDescription === 0 ? (
            <p>{lastHtmlDescription}</p>
          ) : (
            <div className="description-paragraphs-wrapper">
              <div className="description-paragraphs-container">
                {leftHtmlDescription.map((description, index) => (
                  <p key={index}>{description}</p>
                ))}
              </div>
              <div className="description-paragraphs-container">
                {rightHtmlDescription.map((description, index) => (
                  <p key={index}>{description}</p>
                ))}
              </div>
            </div>
          )}
        </div>
      ) : null}
    </div>
  )
}
